import {combineReducers} from "redux";

import handleLoader from '../components/Loader/loaderReducer';
import {handleAuth} from './global/AccountingReducers';
import {handleDrawer} from '../components/Drawer/DrawerReducers';

export default combineReducers({
    handleLoader,
    handleAuth,
    handleDrawer
});
